'use strict';

export default class RichTextBlock {
  constructor() {
    $('.field--type-text-long table').wrap('<div class="rich-text-table-wrapper"></div>');
  }
}
